import { api } from "api/api";
import { AxiosError } from "axios";
import ClassificacaoRequisito from "model/auditoria5s/ClassificacaoRequisito";
import RequisitoAuditoria from "model/auditoria5s/requisitoAuditoria/RequisitoAuditoria";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class RequisitoAuditoriaService implements BaseServiceCadastros<RequisitoAuditoria> {
    

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/requisitoAuditoria/pesquisar`;
            url += getFilters(filters);
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<RequisitoAuditoria>((resolve, reject): void => {
            api
                .get(`/requisitoAuditoria/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(requisitoAuditoria: RequisitoAuditoria) {
        return new Promise<RequisitoAuditoria>((resolve, reject): void => {
            api
                .post(`/requisitoAuditoria/incluir`, JSON.stringify(requisitoAuditoria))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(requisitoAuditoria: RequisitoAuditoria) {
        return new Promise<RequisitoAuditoria>((resolve, reject): void => {
            api
                .put(`/requisitoAuditoria/editar`, JSON.stringify(requisitoAuditoria))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/requisitoAuditoria/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    classificacaoes() {
        return new Promise<ClassificacaoRequisito[]>((resolve, reject): void => {
            api
                .get(`/requisitoAuditoria/classificacoes`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    
    }

    getTiposResposta(){
        return [
            {label: 'Texto', value: 'TEXTO'},
            {label: 'Multipla Escolha', value: 'MULTI_ESCOLHA'},
        ]
    }

}

export default RequisitoAuditoriaService;
